import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {GenerateSimilarImagesParams} from '@wix/document-services-types'
import {generateAndInjectImages} from './utils'
import {type CommonImageFetchParams, fetchSimilarImageUrls} from './requests'
import {ERRORS} from '../constants'

export const generateSimilarImages = async (
    {serverFacade}: Pick<EnvironmentContext, 'serverFacade'>,
    createExtArgs: CreateExtArgs,
    {componentPointers, userRequestInfo, onSuccess, onError}: GenerateSimilarImagesParams
): Promise<void> => {
    return generateAndInjectImages<CommonImageFetchParams>(
        createExtArgs,
        serverFacade,
        componentPointers,
        (_key, url, width, height) => ({
            width_RunwareFlux: width.toString(),
            height_RunwareFlux: height.toString(),
            userImage: url
        }),
        fetchSimilarImageUrls,
        {
            userRequestInfo,
            onSuccess,
            onError,
            caller: 'generateSimilarImages',
            errorType: ERRORS.IMAGES.GENERATE_SIMILAR_IMAGES
        }
    )
}
